import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "core-js/stable"
import React from 'react';
import {createRoot} from "react-dom/client";
import {BrowserRouter} from "react-router-dom";
import {CookiesProvider} from "react-cookie";
import * as serviceWorker from "./serviceWorker";
import {I18nextProvider} from "react-i18next";
// credit i18n https://www.codeandweb.com/babeledit/tutorials/how-to-translate-your-react-app-with-react-i18next
import i18n from './i18n.js';
import CApp2 from "./_/CApp2";
import { createHead, UnheadProvider } from '@unhead/react/client'
// https://github.com/bendotcodes/cookies/tree/main/packages/react-cookie/#simple-example-with-higher-order-component

// https://www.npmjs.com/package/@unhead/react
const head = createHead({ /* config */ })
createRoot(document.getElementById('root')).render(
    <I18nextProvider i18n={i18n}>
        <BrowserRouter>
            <CookiesProvider>
                <UnheadProvider head={head}>
                    <CApp2/>
                </UnheadProvider>
            </CookiesProvider>
        </BrowserRouter>
    </I18nextProvider>
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
